module.exports = __webpack_public_path__ + "static/media/Rounded_Rectanglr.1df3d7e4.svg";